import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyRecord = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 477,
	height: 220.182,
	viewBox: "0 0 477 220.182",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_8857",
		"data-name": "Group 8857",
		transform: "translate(-859.886 -292.909)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_8856",
			"data-name": "Group 8856",
			transform: "translate(859.886 292.909)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group_8855",
				"data-name": "Group 8855",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13637",
						"data-name": "Path 13637",
						d: "M436.825,111.984A141.069,141.069,0,0,1,387.6,64.449,107.9,107.9,0,0,0,266.348,17.421a106.345,106.345,0,0,1-75.169-6.836A108.345,108.345,0,0,0,125.644,1.61,106.656,106.656,0,0,0,38.769,86.952q-.074.393-.145.785a89.551,89.551,0,0,1-23.236,45.474,56.4,56.4,0,0,0,2.293,79.722q1.669,1.577,3.463,3.013H469.4a80.716,80.716,0,0,0-32.572-103.962Z",
						transform: "translate(0 0)",
						fill: "#eff7fc"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13638",
						"data-name": "Path 13638",
						d: "M205.782,331.728h0c0,6.212,3.87,11.248,8.643,11.248H430.483c4.774,0,8.643-5.039,8.643-11.248Z",
						transform: "translate(-76.174 -122.795)",
						fill: "#061a3d"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_14503",
						"data-name": "Rectangle 14503",
						width: 187.188,
						height: 117.57,
						transform: "translate(152.686 81.972)",
						fill: "#84a9ff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13639",
						"data-name": "Path 13639",
						d: "M232.151,110.46H428.338a5.323,5.323,0,0,1,5.323,5.323V242.352a5.323,5.323,0,0,1-5.323,5.323H232.151a5.323,5.323,0,0,1-5.323-5.323V115.783a5.323,5.323,0,0,1,5.323-5.323",
						transform: "translate(-83.964 -40.889)",
						fill: "#032478"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_14504",
						"data-name": "Rectangle 14504",
						width: 187.188,
						height: 117.57,
						transform: "translate(152.686 79.394)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13640",
						"data-name": "Path 13640",
						d: "M320.487,328.981H273.415l.166-2.078.207-2.6h46.326Z",
						transform: "translate(-101.209 -120.048)",
						fill: "#e5e6eb"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13641",
						"data-name": "Path 13641",
						d: "M480.968,328.981H433.9l.167-2.078.207-2.6H480.6Z",
						transform: "translate(-160.614 -120.048)",
						fill: "#e5e6eb"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_14505",
						"data-name": "Rectangle 14505",
						width: 90.843,
						height: 2.641,
						transform: "translate(220.626 167.715)",
						fill: "#a9c2ff"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_14506",
						"data-name": "Rectangle 14506",
						width: 84.562,
						height: 2.641,
						transform: "translate(220.626 179.509)",
						fill: "#a9c2ff"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_14507",
						"data-name": "Rectangle 14507",
						width: 21.84,
						height: 2.641,
						transform: "translate(289.63 173.612)",
						fill: "#a9c2ff"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_14508",
						"data-name": "Rectangle 14508",
						width: 52.226,
						height: 2.641,
						transform: "translate(220.626 173.612)",
						fill: "#a9c2ff"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_14509",
						"data-name": "Rectangle 14509",
						width: 90.843,
						height: 2.641,
						transform: "translate(220.626 138.405)",
						fill: "#a9c2ff"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_14510",
						"data-name": "Rectangle 14510",
						width: 84.562,
						height: 2.641,
						transform: "translate(220.626 150.2)",
						fill: "#a9c2ff"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_14511",
						"data-name": "Rectangle 14511",
						width: 21.84,
						height: 2.641,
						transform: "translate(289.63 144.302)",
						fill: "#a9c2ff"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_14512",
						"data-name": "Rectangle 14512",
						width: 52.226,
						height: 2.641,
						transform: "translate(220.626 144.302)",
						fill: "#a9c2ff"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_14513",
						"data-name": "Rectangle 14513",
						width: 90.843,
						height: 2.641,
						transform: "translate(220.626 107.602)",
						fill: "#a9c2ff"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_14514",
						"data-name": "Rectangle 14514",
						width: 84.562,
						height: 2.641,
						transform: "translate(220.626 119.398)",
						fill: "#a9c2ff"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_14515",
						"data-name": "Rectangle 14515",
						width: 21.84,
						height: 2.641,
						transform: "translate(289.63 113.5)",
						fill: "#a9c2ff"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_14516",
						"data-name": "Rectangle 14516",
						width: 52.226,
						height: 2.641,
						transform: "translate(220.626 113.5)",
						fill: "#a9c2ff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13642",
						"data-name": "Path 13642",
						d: "M472.74,149.162a1.193,1.193,0,0,0-.213,1.275l0,.006a7.917,7.917,0,0,0,2.5,2.747q.226.182.4.334l.09.081.069.063c1.1,1.014.686,1.246,2.663,3.3,2.254,2.345,3.807,2.388,4.248,2.174.374-.183-.385-1.426-1.226-2.824-.041-.067-.081-.135-.122-.2-.112-.186-.224-.375-.334-.562-.986-1.682-.733-2.472-.5-4.976.189-2.035,3.166-11.368,3.166-11.368l-4.319-.744s-1.3,7.432-2.734,8.576c-.767.61-1.624.618-2.361,1.071-.052.031-.1.063-.154.1a5.669,5.669,0,0,0-1.182.95",
						transform: "translate(-174.878 -51.257)",
						fill: "#ffae73"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13643",
						"data-name": "Path 13643",
						d: "M472.74,154.891a1.193,1.193,0,0,0-.213,1.275l0,.006a9.2,9.2,0,0,0,2.507,2.738c.149.126.281.237.4.343l.09.081.069.063c1.1,1.014.686,1.246,2.663,3.3,2.254,2.346,3.807,2.388,4.248,2.174.374-.183-.385-1.426-1.226-2.824a9.6,9.6,0,0,1-4.018-2.96c-1.308-1.669-2.2-3.8-3.086-5.1l-.252-.047a5.671,5.671,0,0,0-1.183.949",
						transform: "translate(-174.878 -56.984)",
						fill: "#1e3865"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13644",
						"data-name": "Path 13644",
						d: "M526.2,145.692c.266,1.333,2.167,1.111,4.29.591s1.619.1,4.641-.236,3.938-1.461,4.031-1.91c.082-.4-1.411-.54-3.013-.724-.2-.023-.4-.047-.606-.072-1.808-.227-3.133-1.394-4.775-2.352-1.556-.908-3.878-4.607-3.878-4.607l-4.145.328s2.175,3.3,3.016,4.74a5,5,0,0,1,.408,2.824,5.268,5.268,0,0,0,.031,1.418",
						transform: "translate(-193.501 -50.484)",
						fill: "#ffae73"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13645",
						"data-name": "Path 13645",
						d: "M532.479,150.416c2.124-.519,1.619.1,4.641-.237s3.938-1.461,4.031-1.91c.083-.4-1.411-.539-3.013-.724l-.014.031a8.516,8.516,0,0,1-4.329,1.345c-2.05.05-4.22-.538-5.638-.515a5.293,5.293,0,0,0,.032,1.418c.266,1.334,2.166,1.112,4.29.592",
						transform: "translate(-195.494 -54.616)",
						fill: "#1e3865"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13646",
						"data-name": "Path 13646",
						d: "M494.65,105.181l-3.875,10.426-5.058,13.613a8.185,8.185,0,0,1-2.687-.246,11.666,11.666,0,0,1-2.6-1.265s1.4-14.617,4.025-23.007a14.942,14.942,0,0,1,2.254-4.877c4.064-4.8,7.94,5.355,7.94,5.355",
						transform: "translate(-177.839 -36.475)",
						fill: "#919191"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13647",
						"data-name": "Path 13647",
						d: "M474.726,81.573c-2.2-.712-7.96-.011-14.2,1.119a4.234,4.234,0,0,1-4.372-1.974l-15.709-1.227S435.261,90.985,438.1,98.31a2.757,2.757,0,0,0,2.745,1.771s9.492.013,12.527.013c7.81,0,16.533-5.37,17.661-5.6,1.846-.369,2.582,3.324,4.432,7.2s17.358,17.173,17.358,17.173a13.677,13.677,0,0,0,3.368-.346,3.323,3.323,0,0,0,1.449-.913S480.451,83.42,474.726,81.573",
						transform: "translate(-161.855 -29.425)",
						fill: "#acadad"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13648",
						"data-name": "Path 13648",
						d: "M445.134,6.785c-5.995-.882-9.606,7.829-9.817,10.46-.389,4.831-2.944,5.568-6.541,8.593-7.212,6.066-5.1,13.115-1.154,15.735,2.366,1.571,6.538,0,6.538,0,.059.041,11.407-6.344,17-9.424,8.385-1.192,1.792-22.489-1.575-24.495",
						transform: "translate(-156.953 -2.489)",
						fill: "#10294c"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13649",
						"data-name": "Path 13649",
						d: "M455.175,37.76c.025.016-2.752.964-4.609.142-1.747-.772-3.07-3.645-3.044-3.647.795-.037,1.667-.731,2.339-5.291l.338.122,5.689,2.048s-.413,1.827-.679,3.563c-.225,1.46-.345,2.856-.035,3.064",
						transform: "translate(-165.657 -10.722)",
						fill: "#ffae73"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13650",
						"data-name": "Path 13650",
						d: "M457.462,31.206s-.227.985-.558,2.824a6.424,6.424,0,0,1-5.131-4.872Z",
						transform: "translate(-167.231 -10.793)",
						fill: "#f9924f"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13651",
						"data-name": "Path 13651",
						d: "M457.975,27.239s-7.784-1.045-7.059-5.882.209-8.23,5.209-7.768,5.687,2.453,5.837,4.126-1.945,9.67-3.988,9.524",
						transform: "translate(-166.896 -5.015)",
						fill: "#ffae73"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13652",
						"data-name": "Path 13652",
						d: "M457.8,52.229c-.235,15.756-.063,12.464-1.788,13.959a6.621,6.621,0,0,1-3.12.676c-4.831.321-13.324-.475-13.647-1.368-1.114-3.086-.328-4.049-1.26-8.779-.1-.5-.217-1.047-.358-1.638-.775-3.248-1.53-4.353,1.221-9.573,2.494-4.728,5.085-8.566,5.318-8.427,6.581,3.9,7.112.624,7.112.624s6.637,6.841,6.522,14.526",
						transform: "translate(-161.73 -13.724)",
						fill: "#25468f"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13653",
						"data-name": "Path 13653",
						d: "M490.773,119.23l-5.058,13.613a8.185,8.185,0,0,1-2.687-.246,11.668,11.668,0,0,1-2.6-1.265s1.4-14.617,4.025-23.007Z",
						transform: "translate(-177.839 -40.099)",
						fill: "#acadad"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13654",
						"data-name": "Path 13654",
						d: "M459.727,38.066s6.771,1.148,7.566,4.063,3.412,20.61,3.412,20.61-1.909,1.864-3.5.275-5-16.555-5-16.555Z",
						transform: "translate(-170.176 -14.091)",
						fill: "#25468f"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13655",
						"data-name": "Path 13655",
						d: "M453.528,74.551c-4.831.321-13.324-.475-13.647-1.368-1.114-3.086-.328-4.049-1.26-8.779l2.33-6.562s-.385,7.306,1.77,9.229,8.823,3.71,9.87,5.316a5.877,5.877,0,0,1,.937,2.163",
						transform: "translate(-162.363 -21.412)",
						fill: "#102c52"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13656",
						"data-name": "Path 13656",
						d: "M453.5,79.057s4.767-1.061,5.536-.638a11.244,11.244,0,0,1,2.883,2.5c.238.536-1.712-.407-2.345-.577a5.678,5.678,0,0,0-2.024.441,6.732,6.732,0,0,1-3.628.364Z",
						transform: "translate(-167.87 -28.991)",
						fill: "#ffae73"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13657",
						"data-name": "Path 13657",
						d: "M439.357,37.073s-6.4.394-8.616,3.484c-3.119,4.35-9.305,22.888-5.76,25.361,3.993,2.784,18.174.728,18.174.728s.472-2.2-.185-3.275-11.326-2.79-11.818-3.283,6.155-9.6,6.155-11.08,2.049-11.935,2.049-11.935",
						transform: "translate(-156.92 -13.723)",
						fill: "#25468f"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13658",
						"data-name": "Path 13658",
						d: "M462.654,80.584a9.226,9.226,0,0,0,1.326,1.442.976.976,0,0,0,.538.116l-.673-1.212Z",
						transform: "translate(-171.259 -29.829)",
						fill: "#ffae73"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13659",
						"data-name": "Path 13659",
						d: "M462.288,78.478l2.9,1.41a.516.516,0,0,1-.481.189,6.924,6.924,0,0,1-1.26-.346Z",
						transform: "translate(-171.124 -29.05)",
						fill: "#ffae73"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13660",
						"data-name": "Path 13660",
						d: "M483.829,83.741H453.5v.67h30.061Z",
						transform: "translate(-167.87 -30.998)",
						fill: "#2cb5a5"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13661",
						"data-name": "Path 13661",
						d: "M464.76,74.7h22.969l6.909-17.182H471.7Z",
						transform: "translate(-172.039 -21.293)",
						fill: "#2cd5c4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13662",
						"data-name": "Path 13662",
						d: "M490.7,70.52a.8.8,0,0,0-.439-1.037.788.788,0,0,0-.341-.057,1.567,1.567,0,0,0-1.407,1.094.8.8,0,0,0,.78,1.093A1.567,1.567,0,0,0,490.7,70.52",
						transform: "translate(-180.811 -25.699)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13663",
						"data-name": "Path 13663",
						d: "M319.107,132.438l3.535.465-2.519,2.523.651,3.506-3.178-1.616-3.133,1.7.555-3.522-2.587-2.456,3.521-.561,1.534-3.218Z",
						transform: "translate(-115.651 -47.847)",
						fill: "#032478"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13664",
						"data-name": "Path 13664",
						d: "M319.107,229.161l3.535.465-2.519,2.523.651,3.506-3.178-1.616-3.133,1.7.555-3.522-2.587-2.456,3.521-.561,1.534-3.218Z",
						transform: "translate(-115.651 -83.651)",
						fill: "#2cd5c4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13665",
						"data-name": "Path 13665",
						d: "M277.779,156.192l3.535.465-2.519,2.523.651,3.506-3.178-1.616-3.133,1.7.555-3.522-2.587-2.456,3.521-.561,1.534-3.218Z",
						transform: "translate(-100.353 -56.64)",
						fill: "#032478"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13666",
						"data-name": "Path 13666",
						d: "M361.018,156.192l3.535.465-2.519,2.523.651,3.506-3.179-1.616-3.133,1.7.555-3.522-2.587-2.456,3.521-.561,1.534-3.218Z",
						transform: "translate(-131.165 -56.64)",
						fill: "#032478"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13667",
						"data-name": "Path 13667",
						d: "M277.779,205.7l3.535.465-2.519,2.523.651,3.506-3.178-1.616-3.133,1.7.555-3.522L271.1,206.3l3.521-.561,1.534-3.218Z",
						transform: "translate(-100.353 -74.965)",
						fill: "#2cd5c4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13668",
						"data-name": "Path 13668",
						d: "M361.018,205.7l3.535.465-2.519,2.523.651,3.506-3.179-1.616-3.133,1.7.555-3.522-2.587-2.456,3.521-.561,1.534-3.218Z",
						transform: "translate(-131.165 -74.965)",
						fill: "#032478"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13669",
						"data-name": "Path 13669",
						d: "M295.7,138.833l3.535.465-2.519,2.524.651,3.506-3.178-1.616-3.133,1.7.555-3.522-2.587-2.456,3.521-.561,1.534-3.218Z",
						transform: "translate(-106.985 -50.214)",
						fill: "#032478"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13670",
						"data-name": "Path 13670",
						d: "M343.748,138.833l3.535.465-2.519,2.524.651,3.506-3.178-1.616-3.133,1.7.555-3.522-2.587-2.456,3.521-.561,1.534-3.218Z",
						transform: "translate(-124.772 -50.214)",
						fill: "#032478"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13671",
						"data-name": "Path 13671",
						d: "M295.7,222.948l3.535.465-2.519,2.523.651,3.506-3.178-1.616-3.133,1.7.555-3.522-2.587-2.456,3.521-.561,1.534-3.218Z",
						transform: "translate(-106.985 -81.351)",
						fill: "#2cd5c4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13672",
						"data-name": "Path 13672",
						d: "M343.748,222.948l3.535.465-2.519,2.523.651,3.506-3.178-1.616-3.133,1.7.555-3.522-2.587-2.456,3.521-.561,1.534-3.218Z",
						transform: "translate(-124.772 -81.351)",
						fill: "#032478"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13673",
						"data-name": "Path 13673",
						d: "M271.165,182.233l3.535.465-2.519,2.523.651,3.506-3.178-1.616-3.133,1.7.555-3.522-2.587-2.456,3.521-.561,1.534-3.218Z",
						transform: "translate(-97.904 -66.28)",
						fill: "#2cd5c4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13674",
						"data-name": "Path 13674",
						d: "M369.125,182.233l3.535.465-2.519,2.523.651,3.506-3.178-1.616-3.133,1.7.555-3.522-2.587-2.456,3.521-.561,1.534-3.218Z",
						transform: "translate(-134.166 -66.28)",
						fill: "#032478"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13675",
						"data-name": "Path 13675",
						d: "M213.989,183.577a4.823,4.823,0,0,0-3.313,4.414V230.58a26.845,26.845,0,0,0,11.071,21.841l25.018,16.033a5.286,5.286,0,0,0,5.593,0l25.019-16.033a26.845,26.845,0,0,0,11.069-21.841V188.1a4.859,4.859,0,0,0-3.477-4.472c-30.392-10.4-42.577-10.683-70.982-.055Z",
						transform: "translate(-77.985 -65.044)",
						fill: "#c3d5fc"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13676",
						"data-name": "Path 13676",
						d: "M307.824,183.641c-14.794-5.065-25.273-7.722-35.407-7.9v93.521a5.206,5.206,0,0,0,2.8-.8l25.018-16.033A26.847,26.847,0,0,0,311.3,230.59V188.113a4.859,4.859,0,0,0-3.477-4.472",
						transform: "translate(-100.84 -65.054)",
						fill: "#a9c2ff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13677",
						"data-name": "Path 13677",
						d: "M267.677,236.954h-5.69a9.265,9.265,0,0,1-9.254-9.255v-1.107a9.266,9.266,0,0,1,9.254-9.259h5.69a9.266,9.266,0,0,1,9.259,9.259V227.7a9.266,9.266,0,0,1-9.259,9.255m-5.69-15.917a5.561,5.561,0,0,0-5.555,5.556V227.7a5.561,5.561,0,0,0,5.555,5.555h5.69a5.56,5.56,0,0,0,5.556-5.555v-1.107a5.561,5.561,0,0,0-5.556-5.556Z",
						transform: "translate(-93.553 -80.45)",
						fill: "#26529f"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13678",
						"data-name": "Path 13678",
						d: "M244.118,236.365h33.318a2.918,2.918,0,0,1,2.917,2.917v21a9.565,9.565,0,0,1-9.563,9.565H252.022a10.183,10.183,0,0,1-10.181-10.181V238.642a2.278,2.278,0,0,1,2.277-2.277",
						transform: "translate(-89.521 -87.494)",
						fill: "#26529f"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13679",
						"data-name": "Path 13679",
						d: "M267.8,244.627a5.022,5.022,0,1,1-3.077,6.4,5.022,5.022,0,0,1,3.077-6.4",
						transform: "translate(-97.887 -90.447)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13680",
						"data-name": "Path 13680",
						d: "M271.778,256.04h0a1.091,1.091,0,0,1,1.088,1.088v8.37a1.088,1.088,0,1,1-2.176,0v-8.37a1.091,1.091,0,0,1,1.088-1.088",
						transform: "translate(-100.2 -94.777)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13681",
						"data-name": "Path 13681",
						d: "M244.2,198.6a4.45,4.45,0,0,1,4.415-4.484h.13a4.76,4.76,0,0,1,3.406,1.189l-1.2,1.449a3.193,3.193,0,0,0-2.267-.882,2.744,2.744,0,0,0,.136,5.475,3.04,3.04,0,0,0,1.8-.52v-1.238h-1.919v-1.648h3.765v3.765a5.625,5.625,0,0,1-3.7,1.375,4.345,4.345,0,0,1-4.553-4.128c-.006-.118-.007-.236,0-.354",
						transform: "translate(-90.393 -71.855)",
						fill: "#26529f"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13682",
						"data-name": "Path 13682",
						d: "M260.226,194.361h3.381a4.343,4.343,0,1,1,0,8.669h-3.381Zm3.381,6.948a2.614,2.614,0,1,0,0-5.228h-1.474v5.228Z",
						transform: "translate(-96.327 -71.946)",
						fill: "#26529f"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13683",
						"data-name": "Path 13683",
						d: "M275.6,194.361h3.543c2.068,0,3.319,1.226,3.319,3.023,0,2.007-1.561,3.046-3.505,3.046H277.51v2.6H275.6Zm3.419,4.372a1.346,1.346,0,0,0,1.512-1.338c0-.855-.595-1.313-1.548-1.313H277.51v2.65Z",
						transform: "translate(-102.019 -71.946)",
						fill: "#26529f"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13684",
						"data-name": "Path 13684",
						d: "M288.738,194.357H292.7a3.455,3.455,0,0,1,2.527.882,2.737,2.737,0,0,1,.743,2.006,2.692,2.692,0,0,1-1.858,2.688l2.118,3.1H294l-1.883-2.771h-1.474v2.771h-1.907Zm3.842,4.211c.929,0,1.461-.5,1.461-1.251,0-.819-.567-1.238-1.5-1.238h-1.9v2.49Z",
						transform: "translate(-106.881 -71.942)",
						fill: "#26529f"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13685",
						"data-name": "Path 13685",
						d: "M162.706,185.848c-.441-.855,9.67-3.933,9.831,4.5,0,0,18.947-.466,9.9-11.026-3.132-3.653-2.809-6.676-2.716-9.493s-1.952-10.993-8.963-10.17a5.227,5.227,0,0,0-4.129.441c-5.212,2.705-16.889,28.855-3.923,25.744",
						transform: "translate(-58.043 -59.014)",
						fill: "#0b3563"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13686",
						"data-name": "Path 13686",
						d: "M215.356,212.361s1.233-1.878,2.227-1.914,2.834-.552,2.687-.185-1.289.4-1.4.626,1.693.552,2.209.589,1.73,0,1.693.258a5.868,5.868,0,0,1-3.708,1.178,10.3,10.3,0,0,0-3.4.441Z",
						transform: "translate(-79.718 -77.783)",
						fill: "#ffae73"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13687",
						"data-name": "Path 13687",
						d: "M187.037,205.827a18.5,18.5,0,0,0,1.89,2.853c1.466,1.836,3.725,3.956,6.562,4.375a7.041,7.041,0,0,0,3.9-.63h0a17.782,17.782,0,0,0,6.037-5.047,2.835,2.835,0,0,0-.387-2.78s-6.958,1.565-7.621,1.234-4.736-9.369-5.47-10.875a8.251,8.251,0,0,0-4.035-4.118Z",
						transform: "translate(-69.235 -70.642)",
						fill: "#2cd5c4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13688",
						"data-name": "Path 13688",
						d: "M189.9,217c1.466,1.836,3.725,3.956,6.562,4.375a7.047,7.047,0,0,0,3.9-.63c-.135.018-3.576.441-4.947-2.011-1.4-2.5-2.912-6.48-4.991-5.155-.9.569-.857,1.99-.523,3.421",
						transform: "translate(-70.215 -78.962)",
						fill: "#2cb5a5"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13689",
						"data-name": "Path 13689",
						d: "M144.787,333.341s-2.123,1.937-1.709,3.314,2.33,2.294,2.589,3.977,1.294,2.6,2.226,2.6h4.443s.687-1.184-.971-1.541-2.282-2.334-2.178-4.169a32.411,32.411,0,0,0-.155-4.283l-3.521-.819Z",
						transform: "translate(-52.943 -123.051)",
						fill: "#074a92"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13690",
						"data-name": "Path 13690",
						d: "M174.18,335.188s-.764,8.208.168,8.667l11.928-.025s0-1.377-1.916-1.682-5.282-1.428-5.852-3.926-4.329-3.034-4.329-3.034",
						transform: "translate(-64.366 -124.075)",
						fill: "#074a92"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13691",
						"data-name": "Path 13691",
						d: "M159.738,199.71a47.631,47.631,0,0,0,0,5.514c.118,1.993,2.135,4.661,2.421,5.324.717,1.656,1.527,1.926,1.527,1.926l6.263,1.536,2.2.539,6.945-2.074s3.163-8.829,1.889-13.8a38.179,38.179,0,0,0-3.212-8.421s-4.707-1.858-13.045-.47Z",
						transform: "translate(-59.1 -70.061)",
						fill: "#2cd5c4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13692",
						"data-name": "Path 13692",
						d: "M162.7,214.706a19.516,19.516,0,0,0,.588,4.511c.718,1.656,1.527,1.926,1.527,1.926l6.263,1.535,2.72-.8s-9.08-1.376-8.074-9.189Z",
						transform: "translate(-60.224 -78.73)",
						fill: "#f8caa4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13693",
						"data-name": "Path 13693",
						d: "M183.047,228.238s3.439,10.707,3.66,14.349-6.574,51.772-6.848,53.453c-.258,1.583-2.223,2.592-2.223,2.592a2.974,2.974,0,0,1-2.194.169,5.428,5.428,0,0,1-2.356-1.111s-2.677-34.326-1.02-46.588a194.142,194.142,0,0,0,1.676-22.863Z",
						transform: "translate(-63.492 -84.486)",
						fill: "#667ee8"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13694",
						"data-name": "Path 13694",
						d: "M159.388,227.732s-5.246,7.039-5.735,11.8-.767,21.471-1.81,26.11-4.87,13.565-4.87,28.032a2.887,2.887,0,0,0,1.627,1.271,13.333,13.333,0,0,0,1.43.4,2.247,2.247,0,0,0,2.515-1.2c2.589-5.211,10.834-22.017,11.256-25.508.3-2.469,2.9-18.809,8.58-28.4,1.364-2.3-.836-11.455-.836-11.455Z",
						transform: "translate(-54.405 -84.299)",
						fill: "#899bfa"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13695",
						"data-name": "Path 13695",
						d: "M181.368,225.615a7.208,7.208,0,0,1-4.124,1.148c-3.275.063-11.394-.835-11.394-.835A6.72,6.72,0,0,0,165.5,228s9.914,2.5,15.659.365a3.632,3.632,0,0,0,.2-2.75",
						transform: "translate(-61.264 -83.515)",
						fill: "#1e3865"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13696",
						"data-name": "Path 13696",
						d: "M183.013,228.456a1.506,1.506,0,1,1,1.495,1.692,1.6,1.6,0,0,1-1.495-1.692m.5,0a1.015,1.015,0,1,0,1-1.2,1.112,1.112,0,0,0-1,1.2Z",
						transform: "translate(-67.744 -84.078)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13697",
						"data-name": "Path 13697",
						d: "M150.788,219.561l9.654-11.08a1.872,1.872,0,0,1,2.64-.181l7.335,6.392a1.87,1.87,0,0,1,.182,2.638h0l-9.655,11.08a1.87,1.87,0,0,1-2.638.181h0l-7.335-6.392a1.87,1.87,0,0,1-.181-2.638",
						transform: "translate(-55.646 -76.935)",
						fill: "#002c75"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13698",
						"data-name": "Path 13698",
						d: "M169.277,228.74c.115.031,4.277.52,4.277,1.38a2.588,2.588,0,0,1-2.37,2.264c-.466-.025-2.613-2-2.613-2Z",
						transform: "translate(-62.399 -84.672)",
						fill: "#ffae73"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13699",
						"data-name": "Path 13699",
						d: "M173.012,186.387a13.86,13.86,0,0,0,.742-5.063l.315.063,5.287,1.047s-.12,1.664-.126,3.231v.039c-.006,1.361.92,2.728-1.264,3.267-.673.167-5.949-.171-4.954-2.584",
						transform: "translate(-63.997 -67.12)",
						fill: "#ffae73"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13700",
						"data-name": "Path 13700",
						d: "M180.047,182.469s-.12,1.664-.126,3.231c-2.96-.083-4.522-2.782-5.164-4.278Z",
						transform: "translate(-64.689 -67.156)",
						fill: "#f48f4e"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13701",
						"data-name": "Path 13701",
						d: "M180.562,178.5s-7,.115-7.005-4.245-.911-7.282,3.558-7.54,5.339,1.4,5.694,2.859-.426,8.784-2.247,8.925",
						transform: "translate(-64.216 -61.702)",
						fill: "#ffae73"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13702",
						"data-name": "Path 13702",
						d: "M178.979,166.04s-1.917,5.116-4.858,5.872-4.22-.032-4.22-.032a8.327,8.327,0,0,0,2.724-4.92s4.908-3.354,6.354-.92",
						transform: "translate(-62.892 -61.134)",
						fill: "#0b3563"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13703",
						"data-name": "Path 13703",
						d: "M183.56,166.73a4.334,4.334,0,0,1,2.006,1.568,7.047,7.047,0,0,1,.945,4s1.444-3.477-.179-5.444c-1.719-2.085-2.772-.127-2.772-.127",
						transform: "translate(-67.948 -61.409)",
						fill: "#0b3563"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13704",
						"data-name": "Path 13704",
						d: "M169.691,228.605a4.747,4.747,0,0,1,1.664-.227c.666.093,1.16-.013,1.16.173s-.861.273-1.044.363a9.088,9.088,0,0,1-1.781-.31",
						transform: "translate(-62.814 -84.536)",
						fill: "#ffae73"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_13705",
						"data-name": "Path 13705",
						d: "M160.433,190.084a8.476,8.476,0,0,0-6.873,4.976c-1.9,4.627-5.519,12.4-5.519,13.712s2.019,5.339,12.86,7.657c0,0,1.121-1.18,1.054-2.112,0,0-6.768-5.813-6.749-6.492.034-1.285,1.11-2.982,7.051-8.925,1.616-1.611-1.823-8.815-1.823-8.815",
						transform: "translate(-54.8 -70.363)",
						fill: "#2cd5c4"
					})
				]
			})
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_13706",
			"data-name": "Path 13706",
			d: "M279.684,2958.281c-.71-2.1-.46-3.154,1.107-4.506.5-.434,1.045-.81,1.569-1.213,1.918-1.13,2.624-3.469,3.963-5.18,2.28-.184,4.577-.149,6.752-1.217,1.146-.563,2.121-1.514,3.356-1.851,2.3.4,2.888,1.989,3.241,3.973a9.389,9.389,0,0,1-.026,3.03c-.822.54-1.035-.286-1.327-.816a22.912,22.912,0,0,0-1.331-2.663c-.538-.729-.932-.726-1.246.265a11.18,11.18,0,0,1-2.518,4.952c-.645.62-1.79.575-2.023,1.571-.217.929.48,1.818.646,2.759a5.587,5.587,0,0,1-1.152,5.011c-3.705,1.084-6.362,3.719-8.411,7.305a2.749,2.749,0,0,0-.093,3.225,6.185,6.185,0,0,1,.42.974c.329,1.486-.27,1.79-1.115,1.688-1.439-.338-2.384-2.508-2.059-4.312a8.718,8.718,0,0,1,.431-1.451,1.9,1.9,0,0,0-.53-2.24c-2.1-2.07-2.06-3.618.106-5.651a1.859,1.859,0,0,0,.54-2.365A2.089,2.089,0,0,1,279.684,2958.281Z",
			transform: "translate(855.896 -2647.405)",
			fill: "#10294c"
		})]
	})
});
export default SvgEmptyRecord;
